import styled, { css } from "styled-components";
import bg from "../../../../Assets/textura_colmeia.png"

export const Wrapper = styled.section`
  padding:10px 16px ;
  gap: 32px;
  position: relative;
  background-image: url(${bg});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  @media (min-width: 768px){
    padding: 32px 64px;
  }

  @media (min-width: 1440px) {
    padding: 48px 120px;
  }
`;

export const ColBox = styled.div`
  display: flex;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  gap: 32px;

  @media (min-width: 768px){
    justify-content: space-between;
  }
`

export const LeftCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  gap: 32px;
  width: 100%;

  @media (min-width: 1100px){
    max-width:570px ;
  }

  h2{
    font-weight: 700;
    font-style: Bold;
    font-size: 40px;
    line-height: 48px;
    letter-spacing: 2px;

    @media (min-width: 850px){
      font-size: 48px;
      line-height: 56px;
      letter-spacing: 2px;
    }
  }

  p{
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 1px;
  }

  button{
    height: 64px;
    opacity: 1;
    border-radius: 8px;
    border-width: 1px;
    padding-top: 8px;
    padding-right: 16px;
    padding-bottom: 8px;
    padding-left: 16px;
    gap: 8px;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: center;
    
    @media (min-width: 768px){
      width: 238px;
    }
  }
`
export const RightCol = styled.div`
  display: none;

  @media (min-width: 1100px){
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 16px;
    align-items: center;
  }
`

export const Item = styled.div`
  border: 1px solid var(--color-ffffff);
  border-radius: 12px;
  overflow: hidden;
  width: 100%;
`;

export const Header = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
  padding: 24px 16px;
  color: #e9efff;
  text-align: left;
`;

export const Title = styled.span`
  font-weight: 600;
  font-style: Semibold;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0px;
`;

export const IconBox = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 8px;
`;

/* área que expande/colapsa (com transição suave) */
export const Panel = styled.div`
  max-height: 0;
  overflow: hidden;
  transition: max-height 220ms ease;
  will-change: max-height;
`;

/* conteúdo interno do painel */
export const PanelInner = styled.div`
  padding: 0 24px 24px 16px;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
`;